import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  text: '',
  stats: null,
}

const wordCounterSlice = createSlice({
  name: 'wordCounter',
  initialState,
  reducers: {
    setText: (state, action) => {
      state.text = action.payload
    },
    calculateStats: (state) => {
      if (!state.text.trim()) {
        state.stats = null
        return
      }

      const text = state.text.trim()
      
      // Basic counts
      const words = text.split(/\s+/).filter(word => word.length > 0)
      const characters = text.length
      const charactersNoSpaces = text.replace(/\s/g, '').length
      const sentences = text.split(/[.!?]+/).filter(s => s.trim().length > 0).length
      const paragraphs = text.split(/\n\n+/).filter(p => p.trim().length > 0).length
      
      // Reading time (average 200 words per minute)
      const readingTime = Math.ceil(words.length / 200)
      
      // Speaking time (average 150 words per minute)
      const speakingTime = Math.ceil(words.length / 150)
      
      // Keyword density
      const wordFrequency = {}
      words.forEach(word => {
        const cleanWord = word.toLowerCase().replace(/[^a-z0-9]/gi, '')
        if (cleanWord.length > 2) {
          wordFrequency[cleanWord] = (wordFrequency[cleanWord] || 0) + 1
        }
      })
      
      const keywordDensity = Object.entries(wordFrequency)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 10)
        .map(([word, count]) => ({
          word,
          count,
          percentage: ((count / words.length) * 100).toFixed(1),
        }))
      
      state.stats = {
        words: words.length,
        characters,
        charactersNoSpaces,
        sentences,
        paragraphs,
        readingTime,
        speakingTime,
        keywordDensity,
      }
    },
    clearStats: (state) => {
      state.stats = null
    },
  },
})

export const { setText, calculateStats, clearStats } = wordCounterSlice.actions
export default wordCounterSlice.reducer
